import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

const SwitchForm = ({
  id,
  name,
  register,
  errors,
  label = "",
  labelRight = "",
  helperText = "",
  disabled = false,
}) => {
  const hasError = errors[id] !== undefined;

  return (
    <Form.Group controlId={id} style={{ marginBottom: "1rem" }}>
      {label && <Form.Label>{label}</Form.Label>}
      <div>
        <div className="form-check form-switch" key={id}>
          {/* <Form.Check {...register(id)} id={id} type="switch" label={name} /> */}
          <label htmlFor={id} className="form-check-label">
            {name}
          </label>
          <input
            {...register(id)}
            id={id}
            className="form-check-input"
            type="checkbox"
            disabled={disabled}
          />
          <label htmlFor={id} className="form-check-label">
            {labelRight}
          </label>
        </div>
      </div>
      {hasError && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {errors[id].message}
        </div>
      )}
      {helperText && <Form.Text muted>{helperText}</Form.Text>}
    </Form.Group>
  );
};

SwitchForm.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  register: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.object).isRequired,
  label: PropTypes.string,
  labelRight: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
};

SwitchForm.defaultProps = {
  name: "",
  label: "",
  labelRight: "",
  helperText: "",
  disabled: false,
};

export default SwitchForm;
